import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { resetPassword } from "../../../features/auth/authSlice";
import toast from "react-hot-toast";
import {
  isRequired,
  isValidPassword,
  passwordsMatch,
  PASSWORD_HINT,
} from "../../../utils/validation";

const eyeOpen = new URL("../../../../assets/eye_open.png", import.meta.url)
  .href;
const eyeClose = new URL("../../../../assets/eye_close.png", import.meta.url)
  .href;

export default function ChangePasswordModal({ email, code, onClose }) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleChange = () => {
    if (loading) return;

    if (!isRequired(newPassword) || !isRequired(confirmPassword)) {
      toast.error("Bitte füllen Sie alle Felder aus!");
      return;
    }

    if (!isValidPassword(newPassword)) {
      toast.error(`Passwort: ${PASSWORD_HINT.toLowerCase()}.`);
      return;
    }

    if (!passwordsMatch(newPassword, confirmPassword)) {
      toast.error("Passwörter stimmen nicht überein!");
      return;
    }

    setLoading(true);

    dispatch(resetPassword({ email, code, newPassword }))
      .unwrap()
      .then(() => {
        toast.success("Password erfolgreich geändert");
        onClose();
      })
      .catch((err) => {
        toast.error(err.message || "Fehler beim ändern des Passworts");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-md">
          <h2 className="kn-h3 mb-4 text-center">Neues Passwort eingeben</h2>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Neues Passwort"
              className="inputStyle w-full "
            />
            <button
              type="button"
              className="absolute right-3 top-1/2 -translate-y-1/2 "
              onClick={() => setShowPassword(!showPassword)}
            >
              <img
                src={showPassword ? eyeOpen : eyeClose}
                className="h-5 w-5"
                alt="Toggle Password"
              ></img>
            </button>
          </div>

          <div className="relative">
            <input
              type={showConfirmPassword ? "text" : "password"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Neues Passwort wiederholen"
              className="inputStyle w-full mb-4 mt-4"
            />
            <button
              type="button"
              className="absolute right-3 top-1/2 -translate-y-1/2 "
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              <img
                src={showConfirmPassword ? eyeOpen : eyeClose}
                className="h-5 w-5"
                alt="Toggle Password"
              ></img>
            </button>
          </div>

          <p className="kn-small mt-2 mb-4">{PASSWORD_HINT}</p>

          <div className="flex justify-between">
            <button onClick={onClose} className="kn-btn-ghost">
              Abbrechen
            </button>
            <button
              onClick={handleChange}
              disabled={loading}
              className="kn-btn-primary"
            >
              {loading ? "Speichern…" : "Bestätigen"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
